export default __webpack_public_path__ + "static/media/warning.98969977.svg";